/******************************************************************
 * @NAME
 * @CREATEDATE 2024
 * @DESC <>
 * ****************************************************************/
import Hls from "hls.js";
import DPlayer from "dplayer";
import SrsSdk from "../../assets/videojs/srs.sdk.js";
import mpegts from "mpegts.js";
/*如果是视频回放需要传时间参数，如果是实时播放，则不需要，只需传递需要播放的设备信息就行*/
let videoArray = {
  video1: [0],
  video4: [0, 1, 2, 3],
  video9: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  video16: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
};
var hlsPlayer = null;
var tsPlayer = null;
export default {
  name: "playVideo",
  props: {
    /*显示的tab样式  
        1 - 线性的Tab标签    
        2 - 填充式的Tab标签   
        -1 - 没有Tab标签，单纯的播放视频（一般用于附件的播放） 
        0 - 没有tab标签,只实现回放或者实时一种功能(目前之争对与Arming Dashboard模块的实时视频)
        */
    tabMode: {
      type: Number,
      default: 1
    },
    //可播放视频的列表
    videoDeviceList: {
      type: Array,
      default() {
        return [];
      }
    },
    //播放那个设备的视频,只要是有多个设备回放的时候，可以点击某个设备回放，子组件需要确认是点击的那个设备
    videoDeviceIndex: {
      type: Number,
      default: 0
    },
    // 回放的时间
    time: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 30
    },
    iconName: {
      //设备图标
      type: String,
      default: "utm-device-camera"
    },
    // 视频的权限codes,若为空数组不限制权限,否则分别传入实时播放和回放的权限code
    videoCodes: {
      type: Array,
      default() {
        return [];
      }
    },
    //是否需要宫格回放,默认是不需要的
    isGongge: {
      type: Boolean,
      default: false
    },
    //是否只是播放实时视频，一般配合tabMode一起使用
    isSingleLive: {
      type: Boolean,
      default: false
    },
    //是否是monitoring模块
    isMonitoring: {
      type: Boolean,
      default: false
    },
    //avigilon筛选
    avigilonlist: {
      type: Array,
      default() {
        return [];
      }
    },
    //Vehicle事件报表
    isVehicle: {
      type: Boolean,
      default: false
    },
    isFacetion: {
      type: Boolean,
      default: false
    },
    isFaceTrack: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    videoDeviceList: {
      handler(nv) {
        //    let videoCodes = this.videoCodes;
        if (this.isGongge) {
          this.initPageInfo(this.pageInfo.limit);
          this.initAccessZone();
        }
        // if (!videoCodes.length || (videoCodes.length > 1 && this.$root.adminInfo.permissionCodes.indexOf(videoCodes[1]) > -1)) {
        //     this.changeTab(1);
        // } else if (!videoCodes.length || (videoCodes.length > 0 && this.$root.adminInfo.permissionCodes.indexOf(videoCodes[0]) > -1)) {
        //     this.changeTab(0);
        // }
      }
    }
  },
  data() {
    return {
      videoApi: window.g.VIDEO_ROOT,
      videoTabIndex: 1,
      videoDeviceInfo: {
        //默认参数
        deviceId: "", //必传，作为播放地址
        deviceName: "",
        accessSiteType: "",
        mapName: ""
      },
      videoUrl: window.g.GLOBAL_API_ROOT,
      videoSrcUrl: "",
      myPlayer: null,
      backPlayer: { url: null, dp: null },
      backHls: null,
      playbackTime: null,
      liveVideoDp: { url: null, dp: null }, //实时视频
      deviceIndex: 0, //当前播放摄像头的下标
      /*多宫格播放视频*/
      videoShrink: true,
      cameraList: [],
      gonggeMaxVideo: videoArray.video4, //视频的最大个数
      pageInfo: {
        Total: 0,
        currentPage: 1,
        limit: 4,
        itemCount: 0
      },
      fullScreenId: "",
      isFull: false,
      accessZoneList: [],
      //放大视频高低画质的切换
      fullCamera: {},
      /*下载视频*/
      downloadFileModal: false,
      downloadInfo: {
        name: "",
        startTime: 0,
        endTime: 0,
        cameraIds: []
      },
      showSetting: false,
      fullscreenElement: null,
      enterVideoItemUrl: "",
      showQuality: false,
      loadingVideoUrl: true
    };
  },
  beforeDestroy() {
    this.closePlayer();
    //如果是播放的多宫格视频则需要循环销毁资源
    if (this.isGongge) {
      console.log(3333, this.cameraList);
      this.disposePlayers(this.cameraList);
    }
  },
  mounted() {
    console.log("获取到的视频列表", this.videoDeviceList);
    if (this.videoDeviceList && this.videoDeviceList.length > 0) {
      if (this.videoDeviceList.length > 1 && this.videoDeviceList.length < 5) {
        this.pageInfo.limit = 4;
      } else if (
        this.videoDeviceList.length > 4 &&
        this.videoDeviceList.length < 10
      ) {
        this.pageInfo.limit = 9;
      } else if (this.videoDeviceList.length > 9) {
        this.pageInfo.limit = 16;
      } else {
        this.pageInfo.limit = 1;
      }
    }
    if (this.pageInfo.limit === 9 || this.pageInfo.limit === 16) {
      this.showSetting = false;
    } else {
      this.showSetting = true;
    }
    this.deviceIndex = this.videoDeviceIndex;
    if (this.isGongge) {
      this.initAccessZone();
      this.changeLimit(this.pageInfo.limit);
    }
    //特殊处理tabMode 为-1是播放的视频附件，直接通过palyVideoUrl()方法使用路径播放，所以省掉了其他逻辑
    // if (this.tabMode !== -1) {
    //     if (this.tabMode === 0 && this.isSingleLive) {
    //         this.changeTab(0);
    //     } else {
    //         this.changeTab(1);
    //     }
    // }
  },
  methods: {
    enterVideoItem(video) {
      if (video) {
        if (video.liveUrl) {
          this.enterVideoItemUrl = video.liveUrl;
        }
        if (video.backUrl) {
          this.enterVideoItemUrl = video.backUrl;
        }
      }
    },
    leaveVideoItem(video) {
      this.enterVideoItemUrl = "";
    },
    changeTab: function(i) {
      this.videoTabIndex = i;
      //单视频播放
      if (this.videoDeviceList.length && !this.isGongge) {
        this.initVideoPlayer(this.videoDeviceList[this.deviceIndex]);
      }
      //多宫格视频播放
      else if (this.isGongge) {
        this.initVideoPlayers();
      }
      /*多宫格视频回放*/
    },
    //释放视频资源
    closePlayer: function() {
      if (tsPlayer) {
        tsPlayer.destroy();
        tsPlayer = null;
      }
      if (hlsPlayer) {
        hlsPlayer.destroy();
        hlsPlayer = null;
      }
      if (this.myPlayer) {
        // this.myPlayer.pause();
        this.myPlayer.removeAttribute("src"); // empty source
        this.myPlayer.load();
      }
      if (this.backPlayer && this.backPlayer.dp && this.tabMode !== -1) {
        this.backPlayer.dp.destroy();
      }
      if (this.backHls) {
        this.backHls.destroy();
      }
      if (this.liveVideoDp && this.liveVideoDp.dp && this.tabMode !== -1) {
        this.liveVideoDp.destroy();
      }
    },
    //创建视频资源
    createPlayer: function() {
      if (!this.myPlayer) {
        this.myPlayer = document.getElementById("deviceVideo");
      }
    },
    changeVideoDevice: function(data, time, deviceIndex) {
      if (!this.isGongge) {
        this.deviceIndex = deviceIndex;
        this.myPlayer = null;
        this.backPlayer = { url: null, dp: null };
        this.liveVideoDp = { url: null, dp: null }; //实时视频
        this.initVideoPlayer(data, time);
      }
    },

    //切换播放视频源
    initVideoPlayer: function(data, time) {
      console.log(456, data, time);

      //切换需要释放资源不然会造成内存泄漏
      if (time) {
        this.playbackTime = time / 1;
      } else {
        this.playbackTime = this.time / 1;
      }
      this.videoDeviceInfo = JSON.parse(JSON.stringify(data));
      if (typeof this.videoDeviceInfo.accessSiteType === "number") {
        this.videoDeviceInfo.direction = this.common.deviceDirection[
          this.videoDeviceInfo.accessSiteType
        ].label;
      } else {
        this.videoDeviceInfo.direction = "-";
      }
      //实时播放
      if (this.videoTabIndex === 0 && !this.liveVideoDp.dp) {
        this.getLiveVideoUrl();
      } else if (
        (this.videoTabIndex === 1 || this.videoTabIndex === -1) &&
        this.playbackTime &&
        !this.backPlayer.dp
      ) {
        //回放视频
        this.getBackVideoUrl();
      } else if (
        (this.videoTabIndex === 1 || this.videoTabIndex === -1) &&
        this.playbackTime &&
        this.backPlayer.dp
      ) {
        //如果视频已经连接不需要重新请求地址，直接播放
        this.backPlayer.dp.seek(0);
      }
    },
    /*直接参入播放地址播放*/
    palyVideoUrl: function(url) {
      this.closePlayer();
      this.videoSrcUrl = url;
      this.createPlayer();
      this.videoTabIndex = -1;
    },

    /* *******************************************************使用切片的形式播放视频服务器的视频*************************************************** */
    //回放
    getBackVideoUrl: function() {
      let _this = this;
      console.log(_this.videoDeviceInfo);
      let palyTime = this.playbackTime;
      let param = {
        cameraId: _this.videoDeviceInfo.deviceId,
        startTime: palyTime - window.g.BACK_VIDEO_START * 1000,
        endTime: palyTime + window.g.BACK_VIDEO_END * 1000,
        type: 2
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          if (res.data.success) {
            let url =
              window.g.BACK_VIDEO_ROOT +
              "playback/" +
              res.data.data.address +
              "/index.m3u8?token=" +
              res.data.data.token;
            _this.backPlayer.url = url;
            _this.$nextTick(() => {
              _this.playBackVideo();
              _this.loadingVideoUrl = false;
            });
          } else {
            _this.loadingVideoUrl = false;
          }
        })
        .catch(() => {
          _this.loadingVideoUrl = false;
        });
    },
    playBackVideo: function() {
      var video = document.getElementById("playbackVideo");
      hlsPlayer = new Hls({
        enableWorker: true, // Improve performance and avoid lag/frame drops.
        lowLatencyMode: true, // Enable Low-Latency HLS part playlist and segment loading.
        liveSyncDurationCount: 50, // Start from the last few segments.
        liveMaxLatencyDurationCount: 51, // Maximum delay allowed from edge of live.
        maxBufferLength: 8, // Maximum buffer length in seconds.
        maxMaxBufferLength: 10, // The max Maximum buffer length in seconds.
        maxLiveSyncPlaybackRate: 1.2, // Catch up if the latency is large.
        liveDurationInfinity: true // Override current Media Source duration to Infinity for a live broadcast.
      });
      hlsPlayer.loadSource(camera.backUrl);
      hlsPlayer.attachMedia(video);
      video.play();
    },
    //首先根据设备的id获取视频的播放地址和token
    getLiveVideoUrl: function() {
      let _this = this;
      this.loadingVideoUrl = true;
      let param = {
        cameraId: _this.videoDeviceInfo.deviceId,
        startTime: 0,
        endTime: 0,
        type: 1
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          if (res.data.success) {
            let url =
              window.g.LIVE_VIDEO_ROOT +
              "live/" +
              res.data.data.address +
              ".ts?token=" +
              res.data.data.token;
            _this.liveVideoDp.url = url;
            _this.liveVideoDp.dp = null;
            _this.$nextTick(() => {
              _this.playLiveVideo();
              _this.loadingVideoUrl = false;
            });
          } else {
            _this.loadingVideoUrl = false;
          }
        })
        .catch(() => {
          _this.loadingVideoUrl = false;
        });
    },
    playLiveVideo: function() {
      if (mpegts.getFeatureList().mseLivePlayback) {
        var videoElement = document.getElementById("liveVideo");
        tsPlayer = mpegts.createPlayer({
          type: "mpegts",
          isLive: true,
          url: _this.liveVideoDp.url,
          enableStashBuffer: false
        });
        tsPlayer.attachMediaElement(videoElement);
        tsPlayer.load();
        tsPlayer.play();
      }
    },

    /******************************************************多宫格视频播放*********************************************/
    shallowCopy(obj) {
      if (typeof obj !== "object" || obj === null) {
        return obj;
      }
      let copy = Array.isArray(obj) ? [] : {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = obj[key];
        }
      }
      return copy;
    },
    deepCopyWithCircular(obj, cache = new WeakMap()) {
      if (obj === null || typeof obj !== "object") {
        return obj;
      }

      // 检查缓存中是否已经存在该对象的拷贝
      if (cache.has(obj)) {
        return cache.get(obj);
      }

      let copy = Array.isArray(obj) ? [] : {};

      // 将当前对象和拷贝对象存入缓存
      cache.set(obj, copy);

      // 检查是否是普通对象，避免非对象类型调用 hasOwnProperty 方法
      if (Object.prototype.toString.call(obj) === "[object Object]") {
        for (let key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            copy[key] = this.deepCopyWithCircular(obj[key], cache);
          }
        }
      }

      return copy;
    },
    //放大视频
    screenChange: function(camera) {
      console.log(77, camera);
      if (camera) {
        this.isFull = true;
        this.fullCamera = this.deepCopyWithCircular(camera);
        this.fullCamera.lowQuality = false;
        if (this.videoTabIndex === 0) {
          this.getCameraLiveUrl(this.fullCamera, 99);
        } else {
          //回放视频
          this.getBackCameraUrl(this.fullCamera, 99);
        }
      } else {
        this.isFull = false;
        if (this.fullCamera.backDp && this.tabMode !== -1) {
          console.log(11);

          this.fullCamera.backDp.destroy();
        }
        if (this.fullCamera.liveDp && this.tabMode !== -1) {
          console.log(33);

          this.fullCamera.liveDp.destroy();
        }
      }
    },
    //切换视频质量
    changeQuality: function() {
      this.$set(this.fullCamera, "lowQuality", !this.fullCamera.lowQuality);
      if (this.videoTabIndex === 0) {
        this.getCameraLiveUrl(this.fullCamera, 99);
      } else if (
        (this.videoTabIndex === 1 || this.videoTabIndex === -1) &&
        this.playbackTime
      ) {
        //回放视频
        this.getBackCameraUrl(this.fullCamera, 99);
      }
    },
    //销毁所有视频资源
    disposePlayers: function(data) {
      if (tsPlayer) {
        tsPlayer.destroy();
        tsPlayer = null;
      }
      if (hlsPlayer) {
        hlsPlayer.destroy();
        hlsPlayer = null;
      }
      for (let camera of data) {
        if (camera.backDp && this.tabMode !== -1) {
          camera.backDp.destroy();
        }
        if (camera.backHls) {
          camera.backHls.destroy();
        }
        if (camera.liveDp && this.tabMode !== -1) {
          camera.liveDp.destroy();
        }
      }
    },
    //初始化视频
    initVideoPlayers: function(time, flag) {
      let _this = this;
      let start = (this.pageInfo.currentPage - 1) * this.pageInfo.limit;
      let end =
        this.pageInfo.currentPage * this.pageInfo.limit >
        this.videoDeviceList.length
          ? this.videoDeviceList.length
          : this.pageInfo.currentPage * this.pageInfo.limit;
      if (time) {
        this.playbackTime = time / 1;
      } else {
        this.playbackTime = this.time / 1;
      }
      _this.disposePlayers(this.cameraList);
      _this.$nextTick(() => {
        let data = JSON.parse(JSON.stringify(_this.videoDeviceList));
        _this.cameraList = data.slice(start, end);
        console.log(7777, _this.cameraList);
        //组装视频的请求地址
        _this.cameraList.forEach((camera, index) => {
          _this.$set(camera, "lowQuality", true);
          //为了跟新地址给地址加上时间戳
          _this.$set(camera, "currentTime", _this.moment().valueOf());
          if (_this.videoTabIndex === 0) {
            _this.getCameraLiveUrl(camera, index);
          } else if (
            (_this.videoTabIndex === 1 || _this.videoTabIndex === -1) &&
            _this.playbackTime
          ) {
            //回放视频
            _this.getBackCameraUrl(camera, index);
          }
        });
        if (flag) {
          _this.gonggeMaxVideo = videoArray["video" + _this.pageInfo.limit];
        }
      });
    },
    /* 九宫格实时视频地址 */
    getCameraLiveUrl: function(camera, index) {
      console.log("宫格实时", camera);
      let _this = this;
      let lowQuality = camera.lowQuality;
      camera.loading = true;
      _this.loadingVideoUrl = true;

      _this.$set(camera, "liveUrl", null);
      let param = {
        cameraId: camera.deviceId,
        startTime: 0,
        endTime: 0,
        type: 1
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          camera.loading = false;
          _this.loadingVideoUrl = false;

          if (res.data.success) {
            let url =
              window.g.LIVE_VIDEO_ROOT +
              "live/" +
              res.data.data.address +
              ".ts?token=" +
              res.data.data.token;
            _this.$set(camera, "liveUrl", url);
            _this.$set(camera, "liveDp", null);
            _this.$nextTick(() => {
              _this.playLiveCamera(camera, index);
            });
          }
        });
    },
    playLiveCamera: function(camera, index) {
      if (mpegts.getFeatureList().mseLivePlayback) {
        var videoElement = document.getElementById("liveVideo" + index);
        tsPlayer = mpegts.createPlayer({
          type: "mpegts",
          isLive: true,
          url: camera.liveUrl,
          enableStashBuffer: false
        });
        tsPlayer.attachMediaElement(videoElement);
        tsPlayer.load();
        tsPlayer.play();
      }
    },
    /* 九宫格回放视频 地址*/
    getBackCameraUrl: function(camera, index) {
      console.log("宫格回放", camera);
      let _this = this;
      let lowQuality = camera.lowQuality;
      camera.loading = true;
      _this.loadingVideoUrl = true;
      _this.$set(camera, "backUrl", null);
      console.log(_this.videoDeviceInfo);
      let palyTime = this.playbackTime;
      let param = {
        cameraId: camera.deviceId,
        startTime: palyTime - window.g.BACK_VIDEO_START * 1000,
        endTime: palyTime + window.g.BACK_VIDEO_END * 1000,
        type: 2
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          camera.loading = false;
          _this.loadingVideoUrl = false;
          console.log(112, res.data.success);
          if (res.data.success) {
            let url =
              window.g.BACK_VIDEO_ROOT +
              "playback/" +
              res.data.data.address +
              "/index.m3u8?token=" +
              res.data.data.token;
            _this.$set(camera, "backUrl", url);
            _this.$set(camera, "backDp", null);
            _this.$nextTick(() => {
              _this.playBackCamera(camera, index);
            });
          }
        });
    },
    playBackCamera: function(camera, index) {
      var video = document.getElementById("playbackVideo" + index);
      hlsPlayer = new Hls({
        enableWorker: true, // Improve performance and avoid lag/frame drops.
        lowLatencyMode: true, // Enable Low-Latency HLS part playlist and segment loading.
        liveSyncDurationCount: 50, // Start from the last few segments.
        liveMaxLatencyDurationCount: 51, // Maximum delay allowed from edge of live.
        maxBufferLength: 8, // Maximum buffer length in seconds.
        maxMaxBufferLength: 10, // The max Maximum buffer length in seconds.
        maxLiveSyncPlaybackRate: 1.2, // Catch up if the latency is large.
        liveDurationInfinity: true // Override current Media Source duration to Infinity for a live broadcast.
      });
      hlsPlayer.loadSource(camera.backUrl);
      hlsPlayer.attachMedia(video);
      video.play();
    },
    /*******************************分页信息****************************/
    initPageInfo: function(limit) {
      this.pageInfo.limit = limit;
      this.pageInfo.currentPage = 1;
      this.pageInfo.itemCount = this.videoDeviceList.length;
      this.pageInfo.Total =
        Math.ceil(this.videoDeviceList.length / this.pageInfo.limit) > 0
          ? Math.ceil(this.videoDeviceList.length / this.pageInfo.limit)
          : 1;
    },
    changeLimit: function(number) {
      if (number === 9 || number === 16) {
        //用于video显示设置按钮
        this.showSetting = false;
      } else {
        this.showSetting = true;
      }
      this.pageInfo.limit = number;
      this.pageInfo.currentPage = 1;
      this.pageInfo.itemCount = this.videoDeviceList.length;
      this.pageInfo.Total =
        Math.ceil(this.videoDeviceList.length / this.pageInfo.limit) > 0
          ? Math.ceil(this.videoDeviceList.length / this.pageInfo.limit)
          : 1;
      console.log(888);

      this.initVideoPlayers(null, true);
    },
    nextPage: function() {
      if (this.pageInfo.currentPage !== this.pageInfo.Total) {
        this.pageInfo.currentPage = this.pageInfo.currentPage + 1;
        this.initVideoPlayers();
      }
    },
    lastPage: function() {
      if (this.pageInfo.currentPage !== 1) {
        this.pageInfo.currentPage = this.pageInfo.currentPage - 1;
        this.initVideoPlayers();
      }
    },
    handleDataSort(list) {
      // 处理数组排序
      return list.slice().sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    //初始化点位和设备列表
    initAccessZone: function() {
      this.accessZoneList = [];
      this.videoDeviceList.forEach((device, index) => {
        let accessZoneArray = device.accessZoneName.split(",").sort((a, b) => {
          return a.localeCompare(b);
        });
        for (let i = 0; i < accessZoneArray.length; i++) {
          let areaInIndex1 = this.accessZoneList.findIndex(value => {
            return value.name === accessZoneArray[i];
          });
          let obj = {
            deviceName: device.deviceName,
            deviceId: device.deviceId,
            isFirst: i === 0
          };

          if (areaInIndex1 > -1) {
            this.accessZoneList[areaInIndex1].devices.push(obj);
          } else {
            this.accessZoneList.push({
              name: accessZoneArray[i],
              devices: [obj]
            });
          }
        }
      });
    },

    /* ****************************视频的下载功能*********************************** */
    downLoadFile: function() {
      this.downloadInfo.cameraIds = [];
      let timeStr = this.moment(this.playbackTime - 30000, "x").format(
        "YYYYMMDDHHmmss"
      );
      this.downloadInfo.name = "Video" + timeStr;
      this.downloadInfo.startTime = this.playbackTime - 30000;
      this.downloadInfo.endTime = this.playbackTime + 30000;
      if (this.avigilonlist.length > 0) {
        this.videoDeviceList.forEach(device => {
          let matchingObj = this.avigilonlist.find(
            item => item.deviceId === device.deviceId
          );
          if (matchingObj) {
            this.downloadInfo.cameraIds.push(device.deviceId);
          }
        });
      } else if (this.isFacetion) {
        this.downloadInfo.cameraIds = this.videoDeviceList.map(device => {
          return device.deviceId;
        });
      } else {
        this.downloadInfo.cameraIds = this.videoDeviceList
          .filter(device => {
            return device.canPlayBackVideo;
          })
          .map(device => {
            return device.deviceId;
          });
      }
      this.downloadFileModal = true;
    },
    //确认下载视频
    confirmDownload: function() {
      let _this = this;
      _this.$validator.validateAll("downloadInfo").then(result => {
        if (result) {
          _this.$ajax
            .post("VideoRecord/Create", _this.downloadInfo)
            .then(function(res) {
              if (res.data.success) {
                _this.messageNotice("success");
                _this.downloadFileModal = false;
              } else {
                _this.messageNotice("error", res.data.message);
              }
            });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/utmPlayVideoMore.js